export const customerTags = [
  'customers_addDebit',
  'customers_addAdvance',
  'customers_addEdit',
] as const;
